import GLightbox from "glightbox";

export class MultiGLightbox {
	constructor(options) {
		this.version = "3.3.1"; // GLightbox version
		this.defaults = {
			url: ".", // url for the ajax call to retrieve the images
			per_page: 10, // used to determine the correct index for paginated images
			selector: null, // the selector for the click event listener (if null, skips the attachListener execution)
			elements: null,
		};
		this.settings = Object.assign({}, this.defaults, options);
		this.is_last_page = false;

		if (this.settings.elements?.length) {
			this.current_page = 0;
			this.instance = GLightbox({
				selector: null,
				elements: this.settings.elements,
			});
			this.attachListener();
		} else {
			this.current_page = 1;
			this.instance = GLightbox({ selector: null });
			this.fetchPage();
		}

		this.instance.on("slide_changed", ({ prev, current }) => {
			if (
				this.instance.nextButton.classList.contains("disabled") &&
				!this.is_last_page
			) {
				this.fetchPage(this.current_page + 1);
			}
		});
	}

	fetchPage(page = 1) {
		const url = new URL(this.settings.url, window.location.origin);
		url.searchParams.append("page", page);
		url.searchParams.append("page", page);
		fetch(url.toString(), {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.length < this.settings.per_page) {
					this.is_last_page = true;
				}
				if (
					page === 1 &&
					(this.settings.elements == null ||
						this.settings.elements.length === 0)
				) {
					const images = [];
					data.forEach((image, index) => {
						images.push({ href: image.image, title: image.title });
					});
					this.instance.setElements(images);
				} else {
					this.current_page = page;
					data.forEach(function (image, index) {
						this.instance.insertSlide({
							href: image.image,
							title: image.title,
						});
					});
				}
				if (this.settings.selector) {
					this.attachListenerToPageEls(page);
				} else {
					this.instance.open();
				}
			});
	}

	attachListenerToPageEls(page) {
		for (const el of document.querySelectorAll(this.settings.selector)) {
			if (Number.parseInt(el.dataset.galleryPage) === page) {
				el.addEventListener("click", (event) => {
					event.preventDefault();
					const page = el.dataset.galleryPage;
					let index = Number.parseInt(el.dataset.galleryIndex);
					index += this.settings.per_page * (page - 1);
					this.instance.openAt(index);
				});
			}
		}
	}

	attachListener() {
		for (const el of document.querySelectorAll(this.settings.selector)) {
			if (el.dataset.galleryPage === page) {
				el.addEventListener("click", (event) => {
					event.preventDefault();
					this.instance.openAt(el.dataset.galleryIndex);
				});
			}
		}
	}
}

export class MultiFreeGLightbox {
	constructor(options) {
		this.version = "3.3.1"; // GLightbox version
		this.defaults = {
			selector: null, // the selector is also used for the click event listener (if null, skips the attachListener execution)
			elements: null,
		};
		this.settings = Object.assign({}, this.defaults, options);

		let elements = [];
		if (this.settings.elements != null) {
			elements = this.settings.elements;
		} else {
			for (const el of document.querySelectorAll(this.settings.selector)) {
				elements.push({ href: el.dataset.gallerySrc });
			}
		}

		this.instance = GLightbox({
			selector: this.settings.selector,
			elements: elements,
		});
		this.attachListener();
	}

	attachListener() {
		for (const el of document.querySelectorAll(this.settings.selector)) {
			el.addEventListener("click", (event) => {
				event.preventDefault();
				this.instance.openAt(el.dataset.galleryIndex);
			});
		}
	}
}
